const standardConfig = {
    input: {
        key: "input",
        label: "输入框",
        type: "input",
        options: {},
    },
    radio: {
        key: "radio",
        label: "单选",
        type: "radio",
        list: [],
        options: {},
    },
    select: {
        key: "select",
        label: "下拉选择",
        type: "select",
        list: [],
        options: {},
    },
    date: {
        key: "date",
        label: "日期选择器",
        type: "date",
        options: {},

    },
    "date-range": {
        key: "date-range",
        label: "日期范围选择器",
        type: "date-range",
        options: {},

    }
}
const filterSelectList = (list, alias) => {
    if (!Array.isArray(list) || !list.length) {
        console.warn('数据格式错误')
        return
    }
    let arr = []
    if (alias === 'nokey') {
        arr = Array.from(list, item => {
            return { text: item, value: item }
        })
    } else if (alias !== undefined) {
        arr = Array.from(list, item => {
            return { text: item[alias.text], value: item[alias.value] }
        })
    } else {
        arr = list
    }
    return arr
}
const configMerge = (config) => {
    let obj = JSON.parse(JSON.stringify(config))
    for (let item of obj) {
        if (item.list) {
            item.list = filterSelectList(item.list, item.listAlias)
        }
        item.options = Object.assign({}, standardConfig[item.type].options, item.options)
        item = Object.assign({}, standardConfig[item.type], item)
    }
    return obj
}
export { configMerge }
